<template>
  <div class="videoCourse">
    <el-card>
      <el-form
        ref="searchForm"
        :model="searchForm"
        :label-width="typeFormLabelWidth"
      >
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="4">
            <el-cascader
              style="width: 100%"
              clearable
              collapse-tags
              v-model="courseIds"
              :show-all-levels="false"
              :props="subjectTreeProp"
              placeholder="请输入所属科目"
              :options="subjectTreeList"
              @change="subjectChangeTop"
            ></el-cascader>
          </el-col>
          <el-col :sm="24" :md="12" :lg="4">
            <el-input
              v-model="searchForm.name"
              placeholder="请输入视频名称"
              auto-complete="off"
              clearable
            ></el-input>
          </el-col>
          <el-col :sm="24" :md="12" :lg="9" style="float: right">
            <div style="float: right" class="flex-starts">
              <el-button-group style="float: right">
                <el-button
                  type="primary"
                  @click="(page.pageNumber = 1), pageList()"
                  icon="el-icon-search"
                  >查询
                </el-button>
                <el-button
                  type="primary"
                  @click="
                    addFormVisible = true;
                    addForm.type = '直播';
                  "
                  v-auth="'/videoCours/addVideoCourse'"
                  icon="el-icon-plus"
                  >添加课程
                </el-button>
                <el-button
                  v-auth="'/videoCours/deleteVideoCourse'"
                  type="danger"
                  @click="batchDeleteVideoCourse"
                  icon="el-icon-minus"
                  >批量删除
                </el-button>
              </el-button-group>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card style="margin-top: 20px">
      <el-row :span="24">
        <el-col :span="12"></el-col>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="width: 100%"
        border
        @selection-change="selectionChange"
        v-loading="videoCourseLoading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="subjectCourseName"
          label="科目课程"
        ></el-table-column>
        <el-table-column
          prop="teacher"
          label="授课老师"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="version"
          label="版本号"
          width="120"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="name"
          label="视频名称"
        ></el-table-column>
        <el-table-column
          width="150"
          :show-overflow-tooltip="true"
          align="center"
          prop="videoCount"
          label="单节点内容/层级内容"
        >
          <template slot-scope="scope">
            <span class="mainColor" @click="opConmon(scope.row)"
              >{{ scope.row.videoCount }}/{{
                scope.row.subjectVideoCount
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          :show-overflow-tooltip="true"
          align="center"
          prop="videoCount"
          label="单节点资料/层级资料"
        >
          <template slot-scope="scope">
            <span class="mainColor" @click="opMaterials(scope.row.id)"
              >{{ scope.row.materialCount }}/{{
                scope.row.materialsCount
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          prop="enabled"
          label="状态"
          align="center"
          width="80"
        >
          <template slot-scope="row">
            <el-switch
              v-model="row.row.enabled"
              :active-value="1"
              :inactive-value="-1"
              @change="updateSwitching(row)"
              class="switchStyle"
              active-text="开"
              inactive-text="关"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop label="操作" width="200" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <i
                v-auth="'/videoCours/updateVideoCourse'"
                class="el-icon-edit icon-style"
                title="编辑"
                @click="
                  dialogTitle = '编辑';
                  selection = scope.row.id;
                  editFormVisible = true;
                "
              ></i>
              <el-button type="text" @click="shareVisibleTrue(scope.row)"
                >分享68</el-button
              >

              <i
                v-auth="'/videoCours/deleteVideoCourse'"
                class="el-icon-delete icon-style"
                title="删除"
                @click="deleteVideoCourse(scope.row)"
              ></i>
              <i
                v-auth="'/videoCours/addVideoCourse'"
                class="mainColor el-icon-document-copy"
                @click="
                  selection = scope.row.id;
                  dialogTitle = '复制';
                  editFormVisible = true;
                "
                title="复制"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="!videoCourseLoading"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        style="margin-top: 20px; text-align: right"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog
      title="添加"
      :visible.sync="addFormVisible"
      width="400px"
      left
      :close-on-click-modal="false"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :label-width="typeFormLabelWidth"
        :rules="addFormRules"
      >
        <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="所属科目课程" prop="courseId">
              <el-cascader
                style="width: 100%"
                clearable
                placeholder="请选择所属科目课程"
                v-model="addForm.courseId"
                :show-all-levels="false"
                :props="subjectTreeProps"
                :options="subjectTreeList"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="授课老师" prop="teacher">
          <el-input
            v-model="addForm.teacher"
            placeholder="请输入授课老师"
            auto-complete="off"
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="版本号" prop="version">
          <el-date-picker
            v-model="addForm.version"
            type="year"
            value-format="yyyy"
            placeholder="请输入版本号"
          >
          </el-date-picker>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="视频课程名称" prop="name">
              <el-input
                v-model="addForm.name"
                placeholder="请输入名称"
                auto-complete="off"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="是否启用" prop="enabled">
              <el-radio-group
                v-model="addForm.enabled"
                placeholder="请选择是否启用"
              >
                <el-radio label="1">启用</el-radio>
                <el-radio label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="水印">
              <div
                v-if="!attchmentUrl"
                class="videoCourse-upload"
                @click="getUrl"
              >
                <i class="el-icon-plus"></i>
              </div>
              <div v-else>
                <img @click="getUrl" class="upload-img" :src="attchmentUrl" />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="水印位置">
              <el-radio-group v-model="addForm.watermarkPosition">
                <el-radio :label="1">左上</el-radio>
                <el-radio :label="2">右上</el-radio>
                <el-radio :label="3">左下</el-radio>
                <el-radio :label="4">右下</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="水印开启">
              <el-radio-group
                v-model="addForm.watermarkState"
                placeholder="请选择是否启用"
              >
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="-1">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="备注说明" prop="remark">
            <el-input
              type="textarea"
              v-model="addForm.remark"
              placeholder="请输入备注"
              auto-complete="off"
              maxlength="300"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addVideoCourse">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="editFormVisible"
      width="400px"
      left
      :close-on-click-modal="false"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="typeFormLabelWidth"
        :rules="editFormRules"
      >
        <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="所属科目课程" prop="courseId">
              <el-cascader
                style="width: 100%"
                clearable
                v-model="editForm.courseId"
                :show-all-levels="false"
                :props="subjectTreeProps"
                placeholder="请选择所属科目课程"
                :options="subjectTreeList"
                @change="subjectChange()"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="授课老师" prop="teacher">
          <el-input
            v-model="editForm.teacher"
            placeholder="请输入授课老师"
            maxlength="5"
          ></el-input>
        </el-form-item>
        <el-form-item label="版本号" prop="version">
          <el-date-picker
            v-model="editForm.version"
            type="year"
            value-format="yyyy"
            placeholder="请输入版本号"
          >
          </el-date-picker>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="视频课程名称" prop="name">
              <el-input
                v-model="editForm.name"
                placeholder="请输入名称"
                auto-complete="off"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="是否启用" prop="enabled">
              <el-radio-group
                v-model="editForm.enabled"
                placeholder="请选择是否启用"
              >
                <el-radio label="1">启用</el-radio>
                <el-radio label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="水印">
              <div
                v-if="!attchmentUrl"
                class="videoCourse-upload"
                @click="getUrl"
              >
                <i class="el-icon-plus"></i>
              </div>
              <div v-else>
                <img @click="getUrl" class="upload-img" :src="attchmentUrl" />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="水印位置">
              <el-radio-group v-model="editForm.watermarkPosition">
                <el-radio :label="1">左上</el-radio>
                <el-radio :label="2">右上</el-radio>
                <el-radio :label="3">左下</el-radio>
                <el-radio :label="4">右下</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="水印开启">
              <el-radio-group
                v-model="editForm.watermarkState"
                placeholder="请选择是否启用"
              >
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="-1">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="备注说明" prop="remark">
            <el-input
              type="textarea"
              v-model="editForm.remark"
              clearable
              placeholder="请输入备注"
              auto-complete="off"
              maxlength="300"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateVideoCourse">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :headers="reqData"
        :file-list="fileList"
      >
        <el-button size="small" type="primary" icon="el-icon-upload"
          >点击上传
        </el-button>
        <div slot="tip" class="el-upload__tip">
          只能上传xls、xlsx文件，且不超过1024kb
        </div>
      </el-upload>
      <el-table
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          prop="courseId"
          label="课程id(第三层) 财务类-初级-经济法"
        ></el-table-column>
        <el-table-column prop="name" label="视频名称"></el-table-column>
        <el-table-column
          prop="type"
          label="类别：免费/付费/会员"
        ></el-table-column>
        <el-table-column prop="price" label="价格"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button type="primary" @click="importData" icon="el-icon-document"
          >导入数据
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="绑定视频" :visible.sync="bindVisible" width="80%" left>
      <conmon v-if="bindVisible" :id="comMonid" :name="typeName"></conmon>
    </el-dialog>
    <el-dialog
      title="资料"
      :visible.sync="bindMaterialsVisible"
      :close-on-click-modal="false"
      width="60%"
    >
      <div style="margin-botton: 20px; height: 40px">
        <el-upload
          class="upload-demo"
          ref="upload"
          action
          :on-change="getUploadNumber"
          :http-request="amountFileUploadRequest"
          multiple
        >
          <el-button type="primary" plain slot="trigger">点击上传</el-button>
        </el-upload>
      </div>
      <div
        style="width: 100%"
        class="draggable-tableaaa"
        v-loading="uploadLoading"
      >
        <div style class="draggable-table">
          <div class="answer bor" style="width: 10%">排序</div>
          <div class="answer bor" style="width: 70%">附件</div>
          <div class="delete bor" style="width: 20%">操作</div>
        </div>
        <draggable
          v-if="materialsImportList.length"
          v-model="materialsImportList"
          @update="datadragEnd"
          :options="{ animation: 500 }"
        >
          <div
            v-for="(element, index) in materialsImportList"
            :key="index"
            class="drag-item"
          >
            <div class="draggable-table">
              <div style="width: 10%" class="answer">{{ index + 1 }}</div>
              <el-tooltip
                :open-delay="500"
                class="item"
                effect="dark"
                :content="element.name"
              >
                <div style="width: 70%" class="answer">
                  {{ element.name || "null" }}
                </div>
              </el-tooltip>
              <div style="width: 20%" class="delete">
                <i
                  class="videoCourse-icon el-icon-download"
                  @click="down(element)"
                ></i>
                <i
                  class="videoCourse-icon el-icon-delete"
                  @click="delect(element)"
                ></i>
              </div>
            </div>
          </div>
        </draggable>
        <div
          v-else
          style="
            text-align: center;
            line-height: 60px;
            color: #909399;
            border-bottom: 1px solid #ebeef5;
            border-right: 1px solid #ebeef5;
          "
        >
          暂无数据
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="选择图片"
      :visible.sync="photoMaterialVisible"
      :close-on-click-modal="false"
      width="60%"
    >
      <photo-material :number="1" @photoListChange="photoListChange" />
    </el-dialog>

    <el-dialog
      title="分享"
      :visible.sync="shareVisible"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-row :gutter="20" style="padding-bottom: 20px">
        <el-col :span="7">
          <div id="qrcode" class="liveList_qrCode"></div>
        </el-col>
        <el-col :span="17">
          <el-input v-model="copyUrl" class="share_input">
            <template slot="append" style="background: #409eff">
              <el-button
                v-clipboard:copy="copyUrl"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                >复制</el-button
              >
            </template>
          </el-input>
          <div style="margin-top: 20px">
            <el-button type="text" @click="savePic">下载二维码</el-button>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { uploadOSS } from "../../upload/upload";
import conmon from "./conmon";
import photoMaterial from "../common/photoMaterial";
import QRCode from "qrcodejs2";
export default {
  components: { conmon, draggable, photoMaterial, QRCode },
  data() {
    return {
      dialogTitle: undefined,
      copyUrl: "",
      viewQrcodeUrl: "",
      shareVisible: false,
      materialsFileAction: `${process.env.POI_URL}/videoInfo/upload`,
      materialsFileList: [],
      uploadNumber: 0,
      uploadArr: [],
      teacherList: [],
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      photoMaterialVisible: false,
      bindVisible: false,
      bindMaterialsVisible: false,
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      typeId: [],
      tencentVideoTypeId: "",
      courseIds: [],
      searchForm: {
        courseIds: [],
        name: "",
        type: "",
      },
      typeTreeList: [],
      typeTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      typeId: [],
      addForm: {
        courseId: "",
        name: "",
        remark: "",
        enabled: "1",
        watermarkState: -1,
        watermarkPosition: 1,
        attachmentId: "",
        version: "",
        teacher: "",
      },
      addFormRules: {
        courseId: [
          {
            required: true,
            message: "请输入课程id(第三层) 财务类-初级-经济法",
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        startTime: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        endTime: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 100,
            message: "名称长度在1到100个字",
          },
        ],
      },
      editForm: {
        courseId: "",
        name: "",
        type: "",
        remark: "",
        watermarkState: -1,
        watermarkPosition: 1,
        attachmentId: "",
        version: "",
        teacher: "",
      },
      editFormRules: {
        type: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        startTime: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        endTime: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        courseId: [
          {
            required: true,
            message: "请输入课程id(第三层) 财务类-初级-经济法",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 100,
            message: "名称长度在1到100个字",
          },
        ],
      },
      importForm: {},
      materialsImportList: [],
      typeFormLabelWidth: "100px",
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      fileAction: `${process.env.BASE_URL}/videoCourse/upload`,
      fileList: [],
      loading: false,
      uploadLoading: false,
      subjectTreeList: [], //科目
      subjectTreeProp: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
      },
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      temple: [],
      videoCourseLoading: "true",
      videoCourseId: "",
      typeName: "",
      comMonid: "",
      MaterialsVideoCourseId: "",
      attchmentUrl: "",
    };
  },
  methods: {
    // 获取水印资源
    getUrl() {
      this.photoMaterialVisible = true;
    },
    // 回传图片id
    photoListChange(ids) {
      this.addForm.attachmentId = ids[0].id;
      this.editForm.attachmentId = ids[0].id;
      this.attchmentUrl = ids[0].url;
      this.photoMaterialVisible = false;
    },
    getTeacherList() {
      this.api.agentUserInfo.getAgentTeacherList().then((result) => {
        this.teacherList = result.data;
      });
    },
    opConmon(row) {
      // this.bindVisible = true;
      // this.comMonid = row.id;
      // this.typeName = row.type;
      this.$router.push({
        path: "/checkVideo",
        query: { id: row.id, name: row.type },
      });
    },
    opMaterials(id) {
      // this.getAliyun();
      // this.MaterialsVideoCourseId = id;
      // this.materialsImportList = [];
      // this.api.videoMaterials
      //   .getVideoMaterials({ videoCourseId: this.MaterialsVideoCourseId })
      //   .then((result) => {
      //     if (result.success) {
      //       this.uploadLoading = false;
      //       this.materialsImportList = result.data ? result.data.attachmentList : [];
      //     }
      //   });
      // this.bindMaterialsVisible = true;
      this.$router.push({
        path: "/checkMaterial",
        query: {
          id,
        },
      });
      // this.typeName = row.type;
    },
    getSubjectTreeList() {
      // 获取课程
      this.api
        .getSubjectCourseTreeList()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTencentVideoTypeTree(row) {
      this.videoCourseId = row;
      this.api.tencentVideoInfo.getTencentVideoTypeTree().then((result) => {
        for (let item of result.data) {
          if (item.children.length != 0) {
            for (let items of item.children) {
              if (items.children.length != 0) {
                for (let itemss of items.children) {
                  delete itemss.children;
                }
              } else {
                // delete items.children;
              }
            }
          } else {
            // delete item.children;
          }
        }
        this.typeTreeList = result.data;
      });
    },
    typeSearchChange() {
      if (this.typeId.length > 0) {
        this.tencentVideoTypeId = this.typeId[2];
      } else {
        this.tencentVideoTypeId = "";
      }
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    startTimeChange() {
      var date = new Date(this.addForm.startTime);
      date.setFullYear(date.getFullYear() + 1);
      date.setDate(date.getDate() - 1);
      this.addForm.endTime = this.format("yyyy-MM-dd hh:mm:ss", date);
    },
    startTimeChangeEdit() {
      var date = new Date(this.editForm.startTime);
      date.setFullYear(date.getFullYear() + 1);
      date.setDate(date.getDate() - 1);
      this.editForm.endTime = this.format("yyyy-MM-dd hh:mm:ss", date);
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map((e) => this.ids.push({ id: e.id }));
    },
    getVideoCourse() {
      this.$nextTick(() => {
        this.$refs.editForm.resetFields();
      });
      this.api.videoCourse
        .getVideoCourse({
          id: this.selection,
        })
        .then((result) => {
          this.editForm = result.data;
          if (result.data.watermarkUrl) {
            this.attchmentUrl = result.data.watermarkUrl;
          } else {
            this.attchmentUrl = "";
          }
          this.editForm.enabled = String(this.editForm.enabled);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageList() {
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.videoCourse
        .pageList(this.searchForm)
        .then((result) => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.videoCourseLoading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addVideoCourse() {
      if (this.blockAddVideoCourse) {
        return false;
      }
      this.blockAddVideoCourse = true;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addForm.courseId = String(this.addForm.courseId[2]);
          this.api.videoCourse
            .addVideoCourse(this.addForm)
            .then((result) => {
              this.addFormVisible = false;
              if (result.success) {
                this.addFormVisible = false;
                this.$message.success(result.message);
                this.blockAddVideoCourse = false;
              } else {
                this.$message.error(result.message);
                this.blockAddVideoCourse = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    subjectChangeTop() {
      this.searchForm.courseIds = [];
      this.courseIds.forEach((e) => {
        this.searchForm.courseIds.push(e[2]);
      });
    },
    subjectChange() {
      this.editForm.courseId = String(this.editForm.courseId[2]);
    },
    updateSwitching(row) {
      let obj = {
        id: row.row.id,
        enabled: row.row.enabled,
      };
      this.api.videoCourse.updateVideoCourseEnable(obj).then((result) => {
        if (result.success) {
          this.pageList();
          this.$message.success(result.message);
        } else {
          this.pageList();
          this.$message.error(result.message);
        }
      });
    },

    datadragEnd(evt) {
      let arr = [];
      this.materialsImportList.forEach((item, index) => {
        arr.push({
          id: item.id,
          sort: index + 1,
        });
      });
      this.api.videoMaterials
        .changeSort(arr)
        .then((result) => {
          this.$message.success(result.message);
        })
        .catch((error) => {
          console.log(error);
        });
      evt.preventDefault();
    },
    updateVideoCourse() {
      if (this.blockUpdateVideoCourse) {
        return false;
      }
      let apiName;
      if (this.dialogTitle == "编辑") {
        apiName = "updateVideoCourse";
      } else {
        apiName = "copyVideoCourse";
      }
      this.blockUpdateVideoCourse = true;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.api.videoCourse[apiName](this.editForm)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.editFormVisible = false;
                this.blockUpdateVideoCourse = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
                this.blockUpdateVideoCourse = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteVideoCourse(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.videoCourse
            .deleteVideoCourse([
              {
                id: row.id,
              },
            ])
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    bindTencentVideoType() {
      let obj = {
        tencentVideoTypeId: this.tencentVideoTypeId,
        videoCourseId: this.videoCourseId,
      };
      this.api.videoCourse.bindTencentVideoType(obj).then((result) => {
        if (result.success) {
          this.bindVisible = false;
          this.tencentVideoTypeId = "";
          this.videoCourseId = "";
          this.$message.success(result.message);
          this.pageList();
        } else {
          this.$message.error(result.message);
        }
      });
    },
    batchDeleteVideoCourse() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.videoCourse
            .deleteVideoCourse(this.ids)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.courseIds = [];
      this.searchForm.type = "";
      this.searchForm.name = "";
      this.courseIds = [];
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    materialsHandleSuccess(response, file, fileList, $event) {
      this.uploadLoading = true;
      let obj = {
        name: file.raw.name,
        size: file.raw.size,
        type: file.raw.type,
        url: response.data.split("?")[0],
      };
      let obj2 = {
        videoCourseId: this.MaterialsVideoCourseId,
        attachment: obj,
      };
      this.api.videoMaterials.addVideoMaterials(obj2).then((result) => {
        if (result.success) {
          this.uploadLoading = false;
          this.materialsImportList.push(obj);
        }
      });
      setTimeout(() => {
        this.uploadLoading = false;
      }, 3000);
    },
    getUploadNumber(files, fileList) {
      this.uploadLoading = true;
      this.uploadNumber = this.uploadNumber + 1;
    },
    // 上传
    amountFileUploadRequest(file) {
      uploadOSS(file, "materials").then((result) => {
        let obj = {
          name: file.file.name,
          size: file.file.size,
          type: file.file.type,
          url: result,
        };
        let obj2 = {
          videoCourseId: this.MaterialsVideoCourseId,
          attachment: obj,
        };
        this.uploadArr.push(obj2);
        if (this.uploadArr.length === this.uploadNumber) {
          this.addBatchVideoMaterials();
        }
      });
    },
    addBatchVideoMaterials() {
      this.api.videoMaterials
        .addBatchVideoMaterials(this.uploadArr)
        .then((result) => {
          if (result.success) {
            this.uploadLoading = false;
            this.uploadArr = [];
            this.uploadNumber = 0;
            this.opMaterials(this.MaterialsVideoCourseId);
          } else {
            this.uploadArr = [];
            this.uploadNumber = 0;
            this.$message.error(result.message);
          }
        });
    },
    down(item) {
      const url = item.url;
      window.open(url);
    },
    delect(item) {
      this.$confirm("系统将删除该文件，是否确认删除？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          let obj = {
            id: item.id,
          };
          this.api.attachment.deleteAttachment([obj]).then((result) => {});
          let result = [];
          this.materialsImportList.forEach((e) => {
            if (e.id !== item.id) {
              result.push(e);
            }
          });
          this.materialsImportList = result;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    exportExcel() {
      this.loading = true;
      this.api.videoCourse
        .exportExcel(this.searchForm)
        .then((result) => {
          location.href = result.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    importData() {
      this.api.videoCourse
        .importData(this.importForm.rows)
        .then((result) => {
          this.$message({
            type: "success",
            message: result.message,
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // ........................................................分享
    // hzkt
    shareHzkt(row) {
      this.copyUrl = row.viewQrcodeUrlByHzkt;
      this.shareVisible = true;
      this.$nextTick(function () {
        document.getElementById("qrcode").innerHTML = "";
        this.liveQrcode(this.copyUrl);
      });
    },
    // 68
    shareVisibleTrue(row) {
      this.copyUrl = row.viewQrcodeUrl;
      this.shareVisible = true;
      this.$nextTick(function () {
        document.getElementById("qrcode").innerHTML = "";
        this.liveQrcode(this.copyUrl);
      });
      // this.copyUrl = row.viewQrcodeUrl
      // this.viewQrcodeUrl = row.viewQrcodeUrl
    },

    liveQrcode(url) {
      console.log(url, "url");
      let qrcode = new QRCode("qrcode", {
        width: 124,
        height: 124,
        text: url, // 二维码内容
      });
    },
    savePic() {
      let myCanvas = document
        .getElementById("qrcode")
        .getElementsByTagName("canvas");
      let a = document.createElement("a");
      a.href = myCanvas[0].toDataURL("image/png");
      a.download = "分享";
      a.click();
      this.$message.success("下载成功!");
    },
    onCopy(e) {
      console.log("11", e);
      this.$message.success("复制成功！");
    },
    onError(e) {
      console.log("22", e);
      this.$message.error("复制失败！");
    },
    // getChannelIdV2 (val) {
    //   this.api.polyvChannel
    //     .getChannelIdV2({ channelNumber: 1882896 })
    //     .then((result) => { });
    // },
    // ........................................................分享
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    },
  },
  watch: {
    $route: {
      handler() {
        // console.log(this.rowId);
        // console.log(999, this.$route);
        if (this.$route.path == "/videoCourse") {
          //编辑时数据详情
          this.pageList();
        }
      },
      deep: true,
    },
    bindVisible: function (newVal) {
      if (!newVal) {
        this.pageList();
      } else {
        this.pageList();
      }
    },
    bindMaterialsVisible: function (newVal) {
      if (!newVal) {
        this.pageList();
        this.materialsImportList = [];
      } else {
      }
    },
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    "editForm.type": function () {
      if (this.editForm.type == "直播") {
        this.editForm.startTime = this.editForm.startTime;
        this.editForm.endTime = this.editForm.endTime;
      } else {
        this.editForm.startTime = "";
        this.editForm.endTime = "";
      }
    },

    "addForm.type": function () {
      if (this.addForm.type == "直播") {
        this.addForm.startTime = this.addForm.startTime;
        this.addForm.endTime = this.addForm.endTime;
      } else {
        this.addForm.startTime = "";
        this.addForm.endTime = "";
      }
    },

    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getVideoCourse();
      }
    },
  },
  mounted() {
    this.pageList();
    this.getSubjectTreeList();
  },
};
</script>
<style scoped>
.videoCourse-icon {
  margin: 0px 10px;
  font-size: 13px;
  color: #409eff;
}

.videoCourse-upload {
  width: 60px;
  height: 60px;
  border: 1px dashed #8c939d;
  border-radius: 4px;
  text-align: center;
  line-height: 60px;
  cursor: pointer;
}

.upload-img {
  width: 60px;
  height: 60px;
  border-radius: 4px;
}
</style>
<style lang="less">
.videoCourse {
  .el-upload-list {
    display: none !important;
  }
}
</style>

<style lang="less" scoped>
.el-icon-document-copy {
  font-size: 16px;
}
.draggable-tableaaa {
  margin-top: 20px;
  border-top: 1px solid #eee;
  border-left: 1px solid #eee;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;

  .bor {
    font-weight: bolder;
    color: #4e4e4e;
    background-color: rgb(250, 250, 250) !important;
  }

  .draggable-table {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    div {
      padding: 8px 10px;
      font-size: 12px;
      line-height: 23px;
    }

    .htmltittles {
      white-space: nowrap;
      padding: 0px;
      overflow: hidden;
      text-overflow: ellipsis;

      img {
        display: none !important;
      }

      p {
        font-size: 12px !important;
        line-height: 23px !important;
        margin: 0px !important;
        color: #606266 !important;
        white-space: nowrap !important;

        img {
          display: none !important;
        }
      }
    }

    .title {
      width: 60%;
      border-bottom: 1px solid #eee;
      border-right: 1px solid #eee;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      .state {
        padding: 0;

        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }

      .questionTypeName {
        padding: 0;

        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }

      white-space: nowrap;
    }

    .answer {
      width: 22%;
      border-bottom: 1px solid #eee;
      border-right: 1px solid #eee;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .delete {
      width: 12%;
      cursor: pointer;
      border-bottom: 1px solid #eee;
      text-align: center;
      border-right: 1px solid #eee;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/videoCourse/index.vue